import { render, staticRenderFns } from "./TableDataMobilePasmo.vue?vue&type=template&id=3c180916&"
import script from "./TableDataMobilePasmo.vue?vue&type=script&lang=ts&"
export * from "./TableDataMobilePasmo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports